<template>
  <div class="page-body instacash-branding">
    <div class="layout-header">
      <img src="~/assets/img/instacash_logo.svg">
    </div>
    <div class="content-body">
      <slot />
    </div>
  </div>
</template>

<script></script>

<style scoped lang="scss">
.page-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  // align-self: stretch;
  // flex-grow: 1;
  flex: 1;
  font-family: Roboto;
  color: var(--ic-branding-black);
  background-color: var(--ic-branding-background);
  // gap: 64px;
}

.content-body {
  flex: 1;
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
}

.layout-header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-shadow: 0px 8px 20px 0px #00000005;

  img {
    display: block;
  }
}
</style>

<style lang="scss">
.instacash-branding {
  --ic-branding-primary: #051c3a;
  --ic-branding-primary-hover: #f2f4f7;
  --ic-branding-primary-light: #adcdf8;
  --ic-branding-secondary: hsl(185, 100%, 23%);
  --ic-branding-secondary-light: hsl(174, 58%, 80%);
  --ic-branding-black: #101828;
  --ic-branding-text-gray: #787878;
  --ic-branding-text-dark-gray: #505050;
  --ic-branding-background: #F7F7F7;
  --gray200: #E2E2E2;
  --gray600: #787878;

  button {
    border: none;
    border-radius: 8px;
    background: var(--ic-branding-primary);
    color: white;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    padding: 16px 64px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.15s ease-in-out;
  
    &:hover {
      background: var(--ic-branding-primary-light);
      color: var(--ic-branding-primary);
    }
  }
  
  * {
    margin: 0;
    padding: 0;
  }
}
</style>